interface HeroProps {
  onContactClick: () => void;
}

export default function Hero({ onContactClick }: HeroProps) {
  return (
    <section className="relative h-96 lg:h-[500px] overflow-hidden">
      <img 
        src="https://static.readdy.ai/image/54a81377d2a88f03463864bd512c4100/c9c0a9e2923ec1ef62e23be1b7282c30.jpeg" 
        alt="確かな技術による電気工事" 
        className="w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      <div className="absolute inset-0 flex flex-col justify-center items-center text-white px-4">
        <h1 className="text-2xl font-bold text-center mb-4 text-green-100">
          確かな技術で<br />安心をつくる。
        </h1>
        <p className="text-sm text-center mb-6 text-green-100">
          配線から大型案件まで<br />お任せください
        </p>
        <button 
          onClick={onContactClick}
          className="bg-primary text-white px-6 py-3 rounded-lg font-medium cursor-pointer whitespace-nowrap hover:bg-green-700 transition-colors"
        >
          お問い合わせ
        </button>
      </div>
    </section>
  );
}
